import React from 'react';
import { GooglePlacesAutocomplete } from '@/components/ui/GooglePlacesAutocomplete';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { useLocation } from '@/contexts/LocationContext';

interface RestaurantSearchInputProps {
  onSelect: (data: {
    name: string;
    place_id: string;
    address: string;
    lat: number;
    lng: number;
    country_code?: string;
  }) => void;
  initialValue?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

export const RestaurantSearchInput: React.FC<RestaurantSearchInputProps> = ({
  onSelect,
  initialValue = '',
  label = 'Restaurant Name *',
  placeholder = 'Search for a restaurant...',
  required = true,
  disabled = false
}) => {
  const { activeLocation, getRadiusInKm } = useLocation();

  // If disabled, show a read-only input with the initial value
  if (disabled) {
    return (
      <div>
        <Label className="text-foreground font-medium">{label}</Label>
        <div className="mt-1">
          <Input
            value={initialValue}
            disabled
            className="border-border bg-muted/50 text-foreground cursor-not-allowed"
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Label className="text-foreground font-medium">{label}</Label>
      <div className="mt-1">
        <GooglePlacesAutocomplete
          types={['restaurant', 'cafe', 'bar', 'bakery', 'fast_food_restaurant']}
          placeholder={placeholder}
          onSelect={onSelect}
          defaultValue={initialValue}
          className="bg-background border-border focus:border-[#cfef00]"
          required={required}
          locationBias={{
            lat: activeLocation.latitude,
            lng: activeLocation.longitude,
            radiusMeters: getRadiusInKm() * 1000,
          }}
        />
      </div>
    </div>
  );
};
